'use strict';
define([
	'../../../base/PureComponent',
    '../../../utils/CommonUtil',
	'../../../utils/GeometryUtil',
	'../../../g2'
], function(
	PureComponent,
    CommonUtil,
    GeometryUtil,g2
) {
	var dataDisplayOnMap = PureComponent.extend({
		options: {
			title: '把数据展示到地图上'
		},
		/*
		 * 初始化方法
		 * @param {Object}
		 * @param options.map 地图对象
		 * */
		initialize: function(options) {
			PureComponent.prototype.initialize.call(this, options);
			//初始化图层组
			this._initLayersGroup();
			//存储标绘和数据信息
			this._plotAndDataObj = {
				plotObj: {},
				dataObj: {}
			}
			this.commandManager = new g2.gdm.CommandManager();
			//创建命令通知实例，用来命令之间的相互通知，传入命令管理对象
			this.commandNotify = new g2.gdm.CommandNotify({
				manager: this.commandManager
			});
		},
		/*
		 * 销毁，对应initialize
		 * */
		destroy: function() {
			this._plotAndDataObj.plotObj = {};
			this._plotAndDataObj.dataObj = {};
			this._syncPlotLayerGroup.clear();
			this._syncPlotLayerGroup.removeAllLayers();
			this._syncVisualizeLayerGroup.clear();
			this._syncVisualizeLayerGroup.removeAllLayers();
			if(this._groupLayer) {
				this._groupLayer.clear();
				this._groupLayer.removeAllLayers();
				this.map.getMap().removeLayer(this._groupLayer);
			}
			//销毁控件
			PureComponent.prototype.destroy.call(this);
		}
	})
	/**
	 * 展示数据前的初始化
	 * */
	dataDisplayOnMap.include({
		/**
		 * 初始化图层组
		 * */
		_initLayersGroup: function() {
			var group = new g2.carto.GroupLayer({
				id: "syncLayerGroup",
				name: "同步数据的图层组",
				layers: []
			});
			this.map.getMap().addLayer(group);
			this._groupLayer = group;
			//保存所有的图层
			this._layers = {};
			//标绘图层组
			var syncPlotLayerGroup = new g2.carto.GroupLayer({
				layers: []
			});
			group.addLayer(syncPlotLayerGroup);
			this._syncPlotLayerGroup = syncPlotLayerGroup;
			//可视化数据组
			var syncVisualizeLayerGroup = new g2.carto.GroupLayer({
				layers: []
			});
			group.addLayer(syncVisualizeLayerGroup);
			this._syncVisualizeLayerGroup = syncVisualizeLayerGroup;
		},
		/**
		 * 获取同步的标绘图层
		 * @param options
		 * options.memberId 对应数据库表中用户的id
		 * @private
		 */
		_getPlotSyncLayer: function(options) {
			options.type = '_syncPlotLayerGroup';
			return this._getSyncLayer(options)
		},
		/**
		 * 获取同步的可视化图层
		 * @param options
		 * options.memberId
		 * @private
		 */
		_getVisualizeSyncLayer: function(options) {
			options.type = '_syncVisualizeLayerGroup';
			return this._getSyncLayer(options)
		},
		/**
		 * 获取同步的标绘图层
		 * @param options
		 * options.memberId 对应数据库表中用户的id
		 * options.type
		 * @private
		 */
		_getSyncLayer: function(options) {
			var type = options.type;
			var memberId = options.memberId || options.userId
			var layerId = type.toLowerCase() + '-' + memberId;
			var layer = null;
			layer = this._layers[layerId];
			if(!layer) {
				layer = new g2.carto.ElementLayer({
					id: layerId,
					map: this.map.getMap()
				});
				this[type].addLayer(layer);
				this._layers[layerId] = layer;
			}
			return layer;
		},
	})
	/**
	 * 地图上展示数据操作
	 * */
	dataDisplayOnMap.include({
		/**
		 * 展示同步数据的数据
		 * @param {Object} options 要展示的数据和发送者标识
		 * @return {String} dataId 批次标绘数据的id
		 * */
		showSyncData: function(options) {
			var dataId = "";
			var memberId = options.memberId || options.userId;
			var data = options.data;
			if(data && data.length > 0) {
				var layer = this._getVisualizeSyncLayer({
					memberId: memberId
				});
				for(var i = 0; i < data.length; i++) {
					layer.add(data[i]);
				}
				//记录每批数据
				dataId = CommonUtil.newUUID();
				if(!this._plotAndDataObj.dataObj[memberId]) {
					this._plotAndDataObj.dataObj[memberId] = {};
				}
				this._plotAndDataObj.dataObj[memberId][dataId] = data;
			}
			return dataId;
		},
		/**
		 * 清除某人同步过来的数据或者清除所有同步过来的数据
		 * @param {String} memberId 需要清除数据人的标识,如果不传清除所有
		 * */
		clearSpecifyOrAllData: function(memberId) {
			if(memberId) {
				var memberIds = memberId.split(",");
				if(memberIds.length > 0) {
					for(var i = 0; i < memberIds.length; i++) {
						var layer = this._getVisualizeSyncLayer({
							memberId: memberIds[i]
						});
						layer.clear();
					}
				}
			} else {
				for(var k in this._layers) {
					if(k.indexOf("_syncvisualizelayergroup") >= 0) {
						this._layers[k].clear();
					}

				}
				this._syncVisualizeLayerGroup.clear();
			}
		},
		/**
		 * 显隐某个人或者所有的人同步过来的图层
		 * @param {String} memberId 需要显隐数据人的标识,如果不传显示隐藏所有
		 * @param {Boolean} visible true显示 false隐藏
		 * */
		visibleSpecifyOrAllData: function(memberId, visible) {
			if(visible == undefined) {
				return;
			}
			if(memberId) {
				var memberIds = memberId.split(",");
				if(memberIds.length > 0) {
					for(var i = 0; i < memberIds.length; i++) {
						var layer = this._getVisualizeSyncLayer({
							memberId: memberIds[i]
						});
						layer.setVisible(visible);
					}
				}
			} else {
				this._syncVisualizeLayerGroup.setVisible(visible);
			}
		},
		/**
		 * 根据数据id查询展示数据
		 * @param {Object} options
		 * @param {String} options.memberId 添加数据成员的标识
		 * @param {String} options.dataId 数据的id
		 * */
		querySyncDataById: function(options) {
			var dataId = options.dataId;
			var memberId = options.memberId || options.userId;
			if(dataId && memberId) {
				var data = this._plotAndDataObj.dataObj[memberId][dataId];
				if(data) {
					var layer = this._getVisualizeSyncLayer({
						memberId: memberId
					});
					layer.clear();
					layer.addElements(data);
				}
			}
		}
	});
	/**
	 * 地图上展示标绘数据
	 * */
	dataDisplayOnMap.include({
		/**
		 * 展示标绘数据
		 * @param {Object} options
		 * @param {String} options.memberId 同步标绘数据人的标识
		 * @param {Object} options.data 同步的标绘数据
		 * @return {String} dataId 批次标绘数据的id
		 * */
		showSyncPlot: function(options) {
			var dataId = "";
			var memberId = options.memberId || options.userId;
			var data = options.data;
			var layer = this._getPlotSyncLayer({
				memberId: memberId
			});
			layer.clear();
			for(var i = 0; i < data.length; i++) {
				layer.add(data[i]);
			}
			this._fitBounds(data[data.length - 1]);
			//记录每批数据
			dataId = CommonUtil.newUUID();
			if(!this._plotAndDataObj.plotObj[memberId]) {
				this._plotAndDataObj.plotObj[memberId] = {};
			}
			this._plotAndDataObj.plotObj[memberId][dataId] = data;
			return dataId;
		},
		/**
		 * 调整视野
		 * @param {plotElement} element
		 * @private
		 */
		_fitBounds: function(element) {
			var envlop = GeometryUtil.getPlotEnvlop([element], this.map.getMap().spatialReference);
			if(envlop) {
				if(envlop.$type.indexOf('Point') >= 0) {
					this.map.getMap().setCenter(envlop);
				} else {
					var offset = 100;
					this.map.getMap().pan(envlop, [offset, offset, offset, offset]);
				}
			}
		},
		/**
		 * 清除某人或者清除所有的标绘
		 * @param {String} memberId 需要清除成员的标识,如果不传清除所有
		 * */
		clearSpecifyOrAllPlot: function(memberId) {
			if(memberId) {
				var memberIds = memberId.split(",");
				if(memberIds.length > 0) {
					for(var i = 0; i < memberIds.length; i++) {
						var layer = this._getPlotSyncLayer({
							memberId: memberIds[i]
						});
						layer.clear();
					}
				}
			} else {
				for(var k in this._layers) {
					if(k.indexOf("_syncplotlayergroup") >= 0) {
						this._layers[k].clear();
					}
				}
				this._syncPlotLayerGroup.clear();
			}
		},
		/**
		 * 显隐某个人或者所有的人同步过来的图层
		 * @param {String} memberId 需要显隐某人的标识,如果不传显示隐藏所有
		 * @param {Boolean} visible true显示 false隐藏
		 * */
		visibleSpecifyOrAllPlot: function(memberId, visible) {
			if(visible == undefined) {
				return;
			}
			if(memberId) {
				var memberIds = memberId.split(",");
				if(memberIds.length > 0) {
					for(var i = 0; i < memberIds.length; i++) {
						var layer = this._getPlotSyncLayer({
							memberId: memberIds[i]
						});
						layer.setVisible(visible);
					}
				}
			} else {
				this._syncPlotLayerGroup.setVisible(visible);
			}
		},
		/**
		 * 根据标绘数据id查询展示数据
		 * @param {Object} options
		 * @param {String} options.memberId 添加标绘成员的标识
		 * @param {String} options.dataId 标绘数据的id
		 * */
		queryPlotDataById: function(options) {
			var dataId = options.dataId;
			var memberId = options.memberId || options.userId;
			if(dataId && memberId) {
				var data = this._plotAndDataObj.plotObj[memberId][dataId];
				if(data) {
					var layer = this._getPlotSyncLayer({
						memberId: memberId
					});
					layer.clear();
					layer.addElements(data);
				}
			}
		}
	})
	return dataDisplayOnMap;
})
